import loadable from '@loadable/component';

export const Changelog = loadable(() =>
  import(/* webpackChunkName: "changelog" */ './changelog')
);
